import React, {Component, useEffect, useState} from "react";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import {toast} from "react-toastify";

import CardDeviceHeader from "./cardDevice/cardDeviceHeader";
import CardDeviceButtonsPanel from "./cardDevice/cardDeviceButtonsPanel";
import CardDeviceNameView from "./cardDevice/cardDeviceNameView";
import CardDeviceTagView from "./cardDevice/cardDeviceTagView";
import CardDeviceWifiView from "./cardDevice/cardDeviceWifiView";

import CardDeviceFooter from "./cardDevice/cardDeviceFooter";


import * as wsCommunication from "../../utils/wsCommunication";

import * as AuthDeviceService from "../../services/authDeviceService";
import * as deviceConf from "../../utils/conf/deviceConf";

import config from "../../config.json";
import CardDeviceAlwaysActiveView from "./cardDevice/cardDeviceAlwaysActiveView";
import TimeSettingsControl from "./confControl/timeSettingsControl";
import BoolValueControl from "./confControl/boolValueControl";
import {handleRossProductionInfo} from "../../utils/handleRossProductionInfo";




function CardDeviceMM({device, forceDataRefresh, onlineDeviceData, onMessageToSent}) {

    const [expanded, setExpanded] = useState(false);
    const [enable, setEnable] = useState(false);



    const handleDemoAction = (data) => {

        wsCommunication.demoMessage(
            device.sn,
            data,
            {},
            onMessageToSent
        );
        handleRossProductionInfo(data, device, onlineDeviceData);

    };

    useEffect(() => {
        updateSettings(device);
    }, []);

    const updateSettings = (device) => {

      
    };

    const handleSendConfiguration = async () => {


        const conf = {

        };

        try {
            const {data} = await AuthDeviceService.postConf({
                _id: device._id,
                conf,
            });

            wsCommunication.forceStatusMessage(device.sn, onMessageToSent);
            toast.success("Nowe ustawienia zostały zapisane!");

            updateSettings(data);
        } catch (err) {
            toast.error("Błąd komunikacji z serwerem");
        }
    };

    const handleDelete = async () => {
        const {data} = await AuthDeviceService.remove(device._id);
        forceDataRefresh();
    };

    return (
        <Card className="mb-2 cursor-pointer" style={{minWidth: "800px"}}>
            <CardDeviceHeader
                expanded={expanded}
                onlineDeviceData={onlineDeviceData}
                device={device}
                settings={{}}
                onAction={handleDemoAction}
                onExpandedClick={() => {
                    setExpanded(~expanded);
                }}
            />

            {expanded ? (
                <React.Fragment>
                    <Card.Body>
                        <CardDeviceNameView
                            device={device}
                            refreshData={forceDataRefresh}
                        ></CardDeviceNameView>
                        
                        <CardDeviceTagView
                            device={device}
                            refreshData={forceDataRefresh}
                        ></CardDeviceTagView>
                        <CardDeviceWifiView
                            device={device}
                            refreshData={forceDataRefresh}
                        ></CardDeviceWifiView>

                        <hr style={{width: "90%", margin: "auto", background: "black"}}></hr>

                        

                        <CardDeviceButtonsPanel
                            onDelete={handleDelete}
                            onSendConfiguration={handleSendConfiguration}
                        />
                    </Card.Body>
                </React.Fragment>
            ) : null}


            <CardDeviceFooter
                device={device}
                onlineDeviceData={onlineDeviceData}
                onChangeConf={handleDemoAction}
            />
        </Card>
    );
}


export default CardDeviceMM;
